import { render, staticRenderFns } from "./ReportPage.vue?vue&type=template&id=2ec18496&scoped=true&"
import script from "./ReportPage.vue?vue&type=script&lang=js&"
export * from "./ReportPage.vue?vue&type=script&lang=js&"
import style0 from "./ReportPage.vue?vue&type=style&index=0&id=2ec18496&scoped=true&lang=scss&"
import style1 from "./ReportPage.vue?vue&type=style&index=1&lang=css&"
import style2 from "./ReportPage.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec18496",
  null
  
)

export default component.exports